export const gatsbyImage = ".gatsby-image-wrapper";
